import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RtlStyleService } from '../../../services/rtl-style-service';
import { MobileNavService } from '../../../services/mobile-nav.service';

@Component({
  selector: 'app-menu',
  imports: [TranslateModule, RouterModule],
  templateUrl: './menu.html',
  styleUrl: './menu.css',
})
export class Menu implements OnInit {
  private router = inject(Router);

  constructor(
    private translate: TranslateService,
    private rtlStyle: RtlStyleService,
    public mobileNav: MobileNavService,
  ) {}

  ngOnInit(): void {
    const lang = this.translate.getCurrentLang();
    this.applyLangStyle(lang);

    this.translate.onLangChange.subscribe(e => {
      this.applyLangStyle(e.lang);
    });
  }

  applyLangStyle(lang: string) {
    if (lang === 'ar') {
      this.rtlStyle.enable();
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      this.rtlStyle.disable();
      document.documentElement.setAttribute('dir', 'ltr');
    }
  }

  currentLangLabel() {
    const lang = this.translate.getCurrentLang();
    switch (lang) {
      case 'fr': return " 🇫🇷 <span class='ms-2'>Français</span>";
      case 'en': return '🇬🇧 <span class="ms-2">English</span>';
      case 'ar': return '🇲🇷 <span class="ms-2">العربية</span>';
      default:   return " 🇫🇷 <span class='ms-2'>Français</span>";
    }
  }

  currentLang() {
    return this.translate.getCurrentLang()!;
  }

  switchLanguage(lang: string) {
    this.translate.use(lang || 'fr');
    localStorage.setItem('preferredLanguage', lang);
    this.applyLangStyle(lang);
    this.updateDirection(lang);
  }

  updateDirection(lang: string) {
    const htmlTag = document.documentElement;
    if (lang === 'ar') {
      htmlTag.setAttribute('dir', 'rtl');
      htmlTag.setAttribute('lang', 'ar');
    } else {
      htmlTag.setAttribute('dir', 'ltr');
      htmlTag.setAttribute('lang', lang);
    }
  }

  /**
   * Navigation vers la home + scroll vers la section carte (.arp-map-section).
   * Si on est déjà sur la home, on scroll directement ; sinon on navigue
   * d'abord puis on scroll après le rendu.
   */
  goToMap(event: Event) {
    event.preventDefault();

    const scrollToMap = () => {
      // Petite attente pour laisser la section différée (@defer) se rendre
      setTimeout(() => {
        const el = document.querySelector('.arp-map-section');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Si la section n'est pas encore montée (lazy load), on réessaie
          setTimeout(() => {
            document.querySelector('.arp-map-section')
              ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 600);
        }
      }, 50);
    };

    if (this.router.url === '/' || this.router.url.startsWith('/?')) {
      scrollToMap();
    } else {
      this.router.navigateByUrl('/').then(() => scrollToMap());
    }
  }
}
